import { createFileRoute } from '@tanstack/react-router'
import { CustomerPickPage } from '../features/availability/public-pages'

/** The customer's signed, single-use pick link (#495). GET shows the windows; confirming POSTs. */
export const Route = createFileRoute('/pick/$token')({
  validateSearch: (raw: Record<string, unknown>): { slot?: string } => ({
    slot: typeof raw.slot === 'string' ? raw.slot.slice(0, 64) : undefined,
  }),
  component: function PickRoute() {
    const { token } = Route.useParams()
    const { slot } = Route.useSearch()
    return <CustomerPickPage token={token} slot={slot} />
  },
})
